// extracted by mini-css-extract-plugin
export default {"Link":"PreviewCard_Link__eqlL5","title":"PreviewCard_title__ClWJA","description":"PreviewCard_description__ok54d","date":"PreviewCard_date__qPPsC","arrow":"PreviewCard_arrow__ih24X"};